import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderEmergenciasComponent } from './order-emergencias/order-emergencias.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    OrderEmergenciasComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class OrderEmergenciasModule { }
